import { Icon } from '@chakra-ui/react';

export const Password = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M5.56364 14L6.18182 13.005L6.8 14L7.74545 13.4958L7.12727 12.5008H8.36364V11.4924H7.12727L7.74545 10.5042L6.8 10L6.18182 10.9882L5.56364 10L4.61818 10.5042L5.23636 11.4924H4V12.5008H5.23636L4.61818 13.4958L5.56364 14ZM10.4364 13.4958L11.3818 14L12 13.005L12.6182 14L13.5636 13.4958L12.9455 12.5008H14.1818V11.4924H12.9455L13.5636 10.5042L12.6182 10L12 10.9882L11.3818 10L10.4364 10.5042L11.0545 11.4924H9.81818V12.5008H11.0545L10.4364 13.4958ZM20 11.4924H18.7636L19.3818 10.5042L18.4364 10L17.8182 10.9882L17.2 10L16.2545 10.5042L16.8727 11.4924H15.6364V12.5008H16.8727L16.2545 13.4958L17.2 14L17.8182 13.005L18.4364 14L19.3818 13.4958L18.7636 12.5008H20V11.4924Z"
      fill="currentColor"
    />
  </Icon>
);
